import { getDateAge } from 'designer/component/action/Data'
import { calDay } from 'designer/component/action/Date'

const patternDateAgeTypeByPattern = {
  yearMonthDay: 'ymd',
  yearMonth: 'ym',
  year: 'y',
  month: 'm',
  day: 'd',
}

const splitFieldsByPattern = {
  yearMonthDay: [
    { configKey: 'yearField', valueKey: 'ageYear' },
    { configKey: 'monthField', valueKey: 'ageMonth' },
    { configKey: 'dayField', valueKey: 'ageDay' },
  ],
  yearMonth: [
    { configKey: 'yearField', valueKey: 'ageYear' },
    { configKey: 'monthField', valueKey: 'ageMonth' },
  ],
  year: [{ configKey: 'yearField', valueKey: 'ageYear' }],
  month: [{ configKey: 'monthField', valueKey: 'ageMonth' }],
  week: [{ configKey: 'weekField', valueKey: 'ageWeek' }],
  day: [{ configKey: 'dayField', valueKey: 'ageDay' }],
}

const getRuleCalculateDateConfig = (action = {}) => {
  return action.config && typeof action.config === 'object'
    ? action.config
    : {}
}

const getRuleCalculateDateFieldKey = (field = {}) => {
  if (typeof field === 'string') return field

  return (
    field.optionValue ||
    field.field ||
    field.valueKey ||
    field.key ||
    field.fieldKey ||
    field.name ||
    field.fieldName ||
    field.fieldPath ||
    ''
  )
}

const getRuleCalculateDateFieldValue = (
  designContext = {},
  field = {},
  data = {},
  getRuleValue = () => undefined,
) => {
  let fieldKey = getRuleCalculateDateFieldKey(field)
  if (!fieldKey) return undefined

  return getRuleValue(
    designContext,
    {
      source: field.source || 'formData',
      field: fieldKey,
    },
    data,
  )
}

const isRuleDateValid = (value) => {
  if (!value) return false

  let date = new Date(value)
  return !Number.isNaN(date.getTime())
}

const getRuleCalculateDateStartValue = (
  designContext = {},
  config = {},
  data = {},
  getRuleValue = () => undefined,
) => {
  return getRuleCalculateDateFieldValue(
    designContext,
    config.startDateField || config.dateField,
    data,
    getRuleValue,
  )
}

const getRuleCalculateDateEndValue = (
  designContext = {},
  config = {},
  data = {},
  getRuleValue = () => undefined,
) => {
  if ((config.endDateMode || 'field') === 'today') return null

  let endDateValue = getRuleCalculateDateFieldValue(
    designContext,
    config.endDateField,
    data,
    getRuleValue,
  )

  if (!endDateValue) return null
  return isRuleDateValid(endDateValue) ? endDateValue : undefined
}

const getRuleCalculateWeekAge = (startDateValue, endDateValue) => {
  let { day } = calDay(startDateValue, endDateValue || undefined)
  if (!Number.isFinite(day)) return undefined

  return Math.floor(day / 7)
}

const getRuleCalculateDateLimitValue = (endDateValue, config = {}) => {
  if (!config.includeLastDay) return endDateValue

  let date = endDateValue ? new Date(endDateValue) : new Date()
  if (Number.isNaN(date.getTime())) return endDateValue

  date.setDate(date.getDate() + 1)
  return date
}

const getRuleCalculateDateAge = (
  startDateValue,
  endDateValue,
  config = {},
) => {
  let pattern = config.pattern || 'yearMonthDay'
  let dateLimit = getRuleCalculateDateLimitValue(endDateValue, config)

  if (pattern === 'week') {
    let week = getRuleCalculateWeekAge(startDateValue, dateLimit)
    if (week === undefined) return null

    return {
      text: `${week} สัปดาห์`,
      values: {
        ageWeek: week,
      },
    }
  }

  let dateAgeType = patternDateAgeTypeByPattern[pattern] || 'ymd'
  let dateAgeConfig = {
    dateAgeType,
  }

  return {
    text: getDateAge(startDateValue, dateAgeConfig, {
      dateLimit,
    }),
    values: getDateAge(startDateValue, dateAgeConfig, {
      isMulti: true,
      dateLimit,
    }),
  }
}

const setRuleCalculateDateOutput = (
  designContext = {},
  config = {},
  target = '',
  age = {},
  setRuleFormData = () => undefined,
) => {
  let outputMode = config.outputMode || 'single'
  let pattern = config.pattern || 'yearMonthDay'

  if (outputMode === 'split') {
    let result = {}
    let fields = splitFieldsByPattern[pattern] || []

    fields.forEach(({ configKey, valueKey }) => {
      let fieldKey = getRuleCalculateDateFieldKey(config[configKey])
      let value = age.values?.[valueKey]

      if (!fieldKey || value === undefined) return

      result[configKey] = value
      setRuleFormData(designContext, fieldKey, value)
    })

    return result
  }

  if (!target || age.text === undefined) return undefined

  setRuleFormData(designContext, target, age.text)
  return age.text
}

export const onRuleCalculateDate = (
  designContext = {},
  action = {},
  data = {},
  options = {},
) => {
  let {
    getRuleValue = () => undefined,
    setRuleFormData = () => undefined,
    target = '',
  } = options
  let config = getRuleCalculateDateConfig(action)
  let startDateValue = getRuleCalculateDateStartValue(
    designContext,
    config,
    data,
    getRuleValue,
  )
  let endDateValue = getRuleCalculateDateEndValue(
    designContext,
    config,
    data,
    getRuleValue,
  )

  if (!isRuleDateValid(startDateValue) || endDateValue === undefined) {
    return undefined
  }

  let age = getRuleCalculateDateAge(startDateValue, endDateValue, config)
  if (!age) return undefined

  return setRuleCalculateDateOutput(
    designContext,
    config,
    target,
    age,
    setRuleFormData,
  )
}
